<template>
  <custom-page-list
    style="margin-top: 20px"
    :first-call="firstCall"
    :grid=" { gutter: 15, column: 3 }"
    :page-size="20"
    :load-data="loadPromise"
    ref="pageList">
    <template slot="list-item" slot-scope="row">
      <div class="l-item-box" @click="onItemClick(row.item)">
        <img class="item-image" :src='row.item.serverLogo'/>
        <div class="right-content-box">
          <a-tooltip placement="topLeft">
            <template slot="title">
              {{ row.item.orderName }}
            </template>
            <span class="title">{{ row.item.orderName }}</span>
          </a-tooltip>

          <div class="content-box">
            <!-- <div class="text">{{row.item.serverBright}}</div> -->
            <a-tooltip placement="topLeft">
              <template slot="title">
                {{ row.item.serverBright }}
              </template>
              <span class="text">{{ row.item.serverBright }}</span>
            </a-tooltip>
          </div>
          <span class="price">{{ row.item.serverPrice }}</span>
        </div>
      </div>
    </template>
  </custom-page-list>
</template>

<script>
import CustomPageList from '../../../customComponents/CustomPageList'

export default {
  name: 'ServiceListComponent',
  components: { CustomPageList },
  props: {
    loadPromise: {
      type: Function,
      default: undefined,
      required: true
    },
    pageSize: {
      type: Number,
      default: 6
    },
    firstCall: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {
    refresh(b = false) {
      this.$refs.pageList.refresh(b)
    },
    onItemClick(record) {
      this.$emit('onItemClick', record)
    }
  }

}
</script>
<style scoped lang="less">
@import "../../CustomPage";

.l-item-box {
  border: 1px solid #e9e9e9;
  height: 140px;
  line-height: 140px;
  padding: 20px;
  cursor: pointer;

  .item-image {
    height: 100px;
    width: 100px;
    margin-right: 20px;
    float: left;
  }

  .right-content-box {
    float: left;
    position: relative;
    height: 100px;
    width: calc(100% - 120px);
    cursor: pointer;

    .title {
      position: absolute;
      top: 5px;
      left: 0;
      height: 16px;
      line-height: 16px;
      font-size: 16px;
      font-weight: bold;
      color: #444444;
      .single-line();
    }

    .content-box {
      position: absolute;
      height: 54px;
      line-height: 54px;
      top: 30px;
      bottom: 20px;

      .text {
        color: #8f8f8f;
        line-height: 20px;
        font-size: 16px;
        overflow: hidden;
        .multi-line(2);
        text-align: left;
      }
    }

    .price {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 14px;
      line-height: 14px;
      color: red;
    }
  }
}
</style>